export default {
    getUsername: (state) => {
      return state.username
    }
  }
  